import React, { forwardRef } from 'react';
import { Anchor } from 'lucide-react';
import { formatLongDate } from '../../utils/gmpBoard';

const Line = ({ label, value, note }) => (
  <div className="flex items-start justify-between gap-3 py-2 text-xs">
    <span className="text-slate-500">{label}</span>
    <span className="text-right">
      <span className="font-bold text-slate-900">{value || 'To be announced'}</span>
      {note && <span className="block text-[10px] text-slate-400">{note}</span>}
    </span>
  </div>
);

// anchor: utils/issueSubscription.js anchorSchedule
export const AnchorBook = forwardRef(({ anchor, priceBand, estimated }, ref) => (
  <section
    ref={ref}
    id="anchor-book"
    aria-labelledby="anchor-heading"
    className="scroll-mt-24 bg-white rounded-2xl border border-slate-200/90 shadow-sm p-4 sm:p-5 flex flex-col"
  >
    <h2 id="anchor-heading" className="flex items-center gap-2 text-sm font-extrabold text-slate-900">
      <Anchor className="w-4 h-4 text-[#008080]" aria-hidden="true" />
      Anchor Investor Book
    </h2>
    <p className="mt-1 text-[11px] text-slate-500">
      Anchors are large institutions allotted shares one working day before the issue opens, at a price within the band
      {priceBand ? ` (${priceBand})` : ''}.
    </p>

    <div className="mt-2 divide-y divide-slate-100">
      <Line label="Anchor bidding date" value={anchor.bidOn && formatLongDate(anchor.bidOn)} note="One working day before opening" />
      <Line
        label="Lock-in ends for 50% of shares"
        value={anchor.lockIn30On && formatLongDate(anchor.lockIn30On)}
        note={`30 days from allotment${estimated ? ' (tentative)' : ''}`}
      />
      <Line
        label="Lock-in ends for remaining 50%"
        value={anchor.lockIn90On && formatLongDate(anchor.lockIn90On)}
        note={`90 days from allotment${estimated ? ' (tentative)' : ''}`}
      />
    </div>

    <p className="mt-auto pt-3 border-t border-slate-100 text-[10px] text-slate-400 leading-relaxed">
      The anchor allocation list, with investor names and amounts, is filed with the exchanges on the anchor bidding date.
      It isn’t part of our data feed yet.
    </p>
  </section>
));

AnchorBook.displayName = 'AnchorBook';

export default AnchorBook;
